import { InjectionToken } from '@angular/core';

/**
 * App-level configuration for `@sisoma/media`, populated per surface by
 * `provideMedia()` (see `./provide-media`).
 */
export interface MediaConfig {
  /**
   * Base URL of the API. Every call the library makes that is *ours* is built
   * from this — the Cloudinary signature endpoint, the user media library, and
   * the stock-provider proxy. The default is empty, which leaves those calls
   * same-origin and relative until an app configures it.
   *
   * Note this is the same value an app passes to `provideAuth({ apiUrl })`, and
   * deliberately so: `authInterceptor` only attaches credentials to requests
   * under *its* `apiUrl`, so a mismatch here would silently strip the cookie and
   * the active-partner header off every media call. The direct-to-Cloudinary
   * upload is the one request that is intentionally outside this base.
   */
  apiUrl: string;
}

export const MEDIA_DEFAULTS: MediaConfig = {
  apiUrl: '',
};

/**
 * Injection token for {@link MediaConfig}. Defaults to {@link MEDIA_DEFAULTS} so
 * the library works unconfigured (and in tests); `provideMedia()` overrides it
 * per app.
 */
export const MEDIA_CONFIG = new InjectionToken<MediaConfig>('MEDIA_CONFIG', {
  providedIn: 'root',
  factory: () => MEDIA_DEFAULTS,
});
